import React from "react";
import "./About.css";
import article1 from "../images/article1.jpeg";
import article2 from "../images/article2.jpeg";

const About = () => {
    return (
        <section className="about-page page-scroll">
            <div className="about-card page-scroll-inner">
                <h1>What is Park Pilot?</h1>
                <p className="About-subtitle">A full stack software application to demonstrate software development skills.</p>
                <p className="About-text">Welcome to Park Pilot.</p>
                <a
                    href="https://www.youtube.com/channel/UClHH5ypytPOyBHmKFYhVYQg"
                    title="valet icons"
                    target="_blank"
                    rel="noopener noreferrer">
                    YouTube University
                </a>
                <p className="About-text">
                    This is software built for customers, for valets and for front line managers. It is driven with powerful technology. Its paperless. It has tenant billing and reporting. It transfers cars between podiums. It does valet queues. It does customer notifications. It does remote requests. Secured vehicle checkouts. Valet key ticket printing. It does reporting on feedback, revenue, trends, tenant accouunts. Lost keys button. It does it all, and it does everything I could think of as
                    a twenty year veteran of the valet industry in Tampa Bay Florida. Simply put a user-friendly interface and robust backend to support your business needs.
                </p>
                <p className="About-text">Whether you're a small local valet service or a large parking management company, Park Pilot is designed to streamline your operations and enhance the customer experience. Try it out today and see how Park Pilot can transform your valet parking business!</p>

                <div className="about-article-section">
                    <h2>How It Started</h2>
                    <p className="About-text about-article-intro">A little over twenty years ago I began my journey in the valet industry.</p>

                    <div className="about-article-preview-wrap">
                        <a
                            href={article2}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="about-article-card about-article-preview"
                            aria-label="Open article 2 in full size">
                            <div className="about-article-image-wrap about-article-image-wrap-preview">
                                <img
                                    src={article2}
                                    alt="Newspaper article about Ryan at an early valet location, article 2."
                                    className="about-article-image"
                                    loading="lazy"
                                />
                            </div>
                            <span className="about-article-caption">TBT - Dec 23 2004</span>
                        </a>

                        <div className="about-article-hover-panel">
                            <a
                                href={article1}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="about-article-card"
                                aria-label="Open article 1 in full size">
                                <div className="about-article-image-wrap about-article-image-wrap-panel">
                                    <img
                                        src={article1}
                                        alt="Newspaper article about Ryan at an early valet location, article 1."
                                        className="about-article-image"
                                        loading="lazy"
                                    />
                                </div>
                                {/* <span className="about-article-caption">TBT - Pg 1</span> */}
                            </a>

                            <a
                                href={article2}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="about-article-card"
                                aria-label="Open article 2 in full size">
                                <div className="about-article-image-wrap about-article-image-wrap-panel">
                                    <img
                                        src={article2}
                                        alt="Newspaper article about Ryan at an early valet location, article 2."
                                        className="about-article-image"
                                        loading="lazy"
                                    />
                                </div>
                                {/* <span className="about-article-caption">TBT - Pg 2</span> */}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
